import React from 'react';
import PropTypes from 'prop-types';

const LockOpen02Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 12.5V10.5M2.3125 5.57143C2.3125 3.039 4.31964 1 6.8125 1C8.36535 1 9.72974 1.7912 10.5379 3M2.5 6.33333C1.675 6.33333 1 7.01905 1 7.85714V15.4762C1 16.3143 1.675 17 2.5 17H11.5C12.325 17 13 16.3143 13 15.4762V7.85714C13 7.01905 12.325 6.33333 11.5 6.33333H2.5Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
  </svg>
);

LockOpen02Icon.propTypes = {
  color: PropTypes.string,
};

export default LockOpen02Icon;
